"use client";
import Container from "@mui/material/Container";
import useTheme from "@mui/material/styles/useTheme";

import LazyImage from "src/lib/components/salify-next-layout/default/components/LazyImage";
import { Paragraph } from "src/lib/components/salify-next-layout/default/components/Typography";

import Grid from "@mui/material/Grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useEffect, useState } from "react";
import SalifyLink from "src/lib/components/link/salify-link";
import { toAssetImages } from "src/lib/utils";
import { StyledBox } from "../header/footmart/styles";
import { Carousel } from "../salify-next-layout/default/components/carousel";
import { COMMON_DOT_STYLES } from "../salify-next-layout/default/components/carousel/styles";
import { CarouselButton, GridItemOne, GridItemTwo, StyledGrid } from "./footmart/styles";
import { FlexBox } from "../salify-next-layout/default/components/flex-box";
import { footMartLayoutConstant } from "src/lib/utils/constants";

export type ICarouselItem = {
  id: string;
  title?: string;
  subTitle?: string;
  leftButton?: { text: string; link: string };
  rightButton?: { text: string; link: string };
  backgroundImgUrl?: string;
  imgUrl?: string;
};

export interface VariantProps {
  linkTo: string;
  carouselData: Array<ICarouselItem>;
  mobileImgOff?: boolean;
}

const CarouselSection: React.FC<VariantProps> = ({ linkTo, carouselData, mobileImgOff }) => {
  const { palette } = useTheme();
  const isMobile = useMediaQuery("(max-width:767px)");

  const [carouselDataState, setCarouselDataState] = useState<ICarouselItem[]>([]);

  useEffect(() => {
    setCarouselDataState(
      carouselData.map((data) => {
        if (data.backgroundImgUrl && !mobileImgOff) {
          const backgroundImgUrl = isMobile
            ? data.backgroundImgUrl.replace(".", "-mobile.")
            : data.backgroundImgUrl;
          return {
            ...data,
            backgroundImgUrl,
          };
        }
        return data;
      }),
    );
  }, [carouselData, isMobile]);

  return (
    <StyledBox id="carouselBox">
      <Container
        style={{
          backgroundColor: "#e6f3fa",
          borderRadius: "20px",
          margin: isMobile ? "20px 0px 0px 0px" : "20px",
          padding: isMobile ? "0px" : "20px",
        }}
        maxWidth={false}
        sx={{ maxWidth: footMartLayoutConstant.containerWidth }}
        disableGutters={true}
      >
        <Carousel
          dots
          arrows={false}
          spaceBetween={0}
          slidesToShow={1}
          arrowStyles={undefined}
          dotColor={palette.primary.main}
          dotStyles={COMMON_DOT_STYLES as any}
          className="mb-[-6px]"
        >
          {carouselDataState.map(
            ({ id, title, subTitle, backgroundImgUrl, leftButton, rightButton, imgUrl }) =>
              backgroundImgUrl ? (
                <FlexBox key={id}>
                  <StyledGrid container>
                    <Container maxWidth="lg" sx={{ height: "100%" }}>
                      <GridItemOne
                        item
                        sx={
                          backgroundImgUrl
                            ? { position: "absolute", top: 0, bottom: 0, color: "white" }
                            : null
                        }
                        display={"flex"}
                        flexDirection={"column"}
                        justifyContent={"top"}
                      >
                        <div className="titleBox">
                          <div style={{ color: "black", fontSize: "24px" }}>{title}</div>
                          <Paragraph
                            style={{
                              color: "black",
                              fontSize: isMobile ? "16px" : "30px",
                              maxWidth: isMobile ? "150px" : "100%",
                            }}
                          >
                            {subTitle}
                          </Paragraph>
                        </div>
                      </GridItemOne>

                      <GridItemOne
                        item
                        sx={
                          backgroundImgUrl
                            ? { position: "absolute", top: 0, bottom: 0, color: "white" }
                            : null
                        }
                        display={"flex"}
                        flexDirection={"column"}
                        justifyContent={"center"}
                      >
                        <Grid
                          container
                          spacing={"13px"}
                          justifyContent={{ xs: "center", sm: "flex-start" }}
                        >
                          {leftButton && (
                            <Grid item>
                              <SalifyLink href={leftButton.link}>
                                <CarouselButton variant="contained" color="primary">
                                  {leftButton.text}
                                </CarouselButton>
                              </SalifyLink>
                            </Grid>
                          )}
                          {rightButton && (
                            <Grid item>
                              <SalifyLink href={rightButton.link}>
                                <CarouselButton variant="outlined">
                                  {rightButton.text}
                                </CarouselButton>
                              </SalifyLink>
                            </Grid>
                          )}
                        </Grid>
                      </GridItemOne>

                      {imgUrl && (
                        <GridItemTwo item md={6} sm={6} xs={12}>
                          <LazyImage
                            priority
                            alt={`${title}`}
                            width={600}
                            height={450}
                            src={imgUrl}
                          />
                        </GridItemTwo>
                      )}
                    </Container>
                  </StyledGrid>
                  <LazyImage
                    src={toAssetImages(backgroundImgUrl)}
                    alt={`banner-${id}`}
                    width={isMobile ? 230 : 320}
                    height={isMobile ? 230 : 470}
                    style={{
                      borderRadius: 8,
                    }}
                  />
                </FlexBox>
              ) : null,
          )}
        </Carousel>
      </Container>
    </StyledBox>
  );
};

export default CarouselSection;
